import React, { useEffect, useState } from 'react';
import InputField from '../UI/Input/InputField';
import ButtonField from '../UI/Button/ButtonField';
import { MDBRow, MDBCol } from 'mdbreact';
import Card from "../Card/Card";
import {Row} from "react-bootstrap";
import { FetchAPI } from '../../api/fetch';
import './FilterBox.css';
import { isEmpty } from 'components/Login/validator';
import BeatLoader from "react-spinners/BeatLoader";
import useValidator from 'hooks/useValidator';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import { PostAPI } from "api/post";
const cookies = new Cookies();

const FilterBox = ( props ) => {
    const { t, i18n } = useTranslation();
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
    const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
    const formElementsArray = [];
    const [validator, showValidationMessage] = useValidator();
    const initialValue = [{displayValue: `${t('please_select')}`, value: ''}];
    let [FilterformValues, setFilterformValues] = useState(props.formValue);
    let [loadSForm, setloadSForm] = useState(true);
    let [selectedFile, setSelectedFile] = useState(null); 
    let [fromDate, setFromDate] = useState();
    let [toDate, setToDate] = useState();
    let getdrpdwnresponse;
    let conditionTextStyles = {
        fontSize:'14px',
        fontWeight:"500",
        color:"#ff3547",
        marxgin:'0',
        padding:'15px 20px'
    }
    let commonParams = {
        customer_id:cookies.get('customer_id'),
        user_id:cookies.get('user_id'),
        userLocation_id:cookies.get('userLocation_id'),
        userRole_name:cookies.get('userRole_name'),
        language:language
    }
    for (let key in FilterformValues){
        formElementsArray.push({
            id: key,
            config: FilterformValues[key]
        });
    }
    async function filteredExport(e) {
        if(props.title !== 'Log'){
            if (validator.allValid()) {
                props.setformValues(FilterformValues)
                props.filteredExport(FilterformValues);
            } else{
                showValidationMessage(true)
            }
        }
        else if (props.title === 'Log') {
            formElementsArray.map(function(formElement, indexIdx){
                if(formElement.id === "to_date" || formElement.id === "from_date" || formElement.id === "product_id"){
                    formElement.config.validate.required = false
                }
            })
            if(validator.allValid()){
                 props.filteredExport(FilterformValues);
                props.setformValues(FilterformValues)
            }
            else{
                showValidationMessage(true);
            }
        }
	}
    async function filteredExport1(e) {
        props.setformValues(FilterformValues)
        props.filteredExport1(FilterformValues);
    }
    
    const resetFilterFormValues = () => {
        const resetFormValues = {
            ...FilterformValues
        }
        for (let formvalue in resetFormValues) {
            if (resetFormValues[formvalue].elementType === "multiselect") {
                resetFormValues[formvalue].elementConfig.options = []
            }
        }
        setFilterformValues(resetFormValues)
    }

      const clearFunction = (event) => {
        props.clearClick();
      }
    const checkValidationFirst = (event) => {
        if (validator.allValid()) {
            props.setformValues(FilterformValues)
            props.searchClick(FilterformValues);
        }
        else{
        showValidationMessage(true);
        }
    }
    let searchFormData = {}
    for (let inputIdentifier in FilterformValues) {
        searchFormData[inputIdentifier] = FilterformValues[inputIdentifier].value;
    } 
    
    async function inputChangedHandler(event,inputIdentifier) {
        const updateOrderForm = {
          ...FilterformValues
        }
        const updateElemetForm = {
          ...updateOrderForm[inputIdentifier]
        };
        if(updateOrderForm[inputIdentifier].elementType == 'multiselect') {
            if(Array.isArray(event) && event.length !== 0)
                updateElemetForm.value = event;
            else
                updateElemetForm.value = null;
        }
        else if(updateOrderForm[inputIdentifier].elementType == 'selectshowsearch') {
            updateElemetForm.value = event;
    }
        else if(updateOrderForm[inputIdentifier].elementType == 'select'){ 
            if(event.target.value !== `${t('please_select')}`){
            updateElemetForm.value = event.target.value;
            }else{
                updateElemetForm.value = null;
            }
        }
        else if(event.target.type === 'checkbox') {
            updateElemetForm.value = event.target.checked;
        }
        else if((updateOrderForm[inputIdentifier].elementType === 'file')) {
           
            if(event.target.files[0])
            setSelectedFile(event.target.files[0])
            let ext;
            if(event.target.files[0]) {
                ext = event.target.files[0].name.split(".")[1];
            }
                let formData;
                const data = new FormData() 
                data.append('file', event.target.files[0])
                data.append('formValues',searchFormData)
                const getURL='https://c1m36osb45.execute-api.ap-south-1.amazonaws.com/dev/iot-status/import-iot';
                let responseData = await PostAPI(getURL, data);
                    if(responseData.status == 200)
                        swal('sucess','success')
                    else
                      swal('Something went wrong','Please try again','error')

        }
        else {
            if(event.target.value && event.target.value !== 'Select Line')
                updateElemetForm.value = event.target.value;
            else
                updateElemetForm.value = null;
        }
        updateOrderForm[inputIdentifier] = updateElemetForm;
        props.filteredExport2(updateOrderForm);
        setFilterformValues(updateOrderForm);
        if(updateOrderForm[inputIdentifier].elementType == 'select' ){
            if(updateOrderForm[inputIdentifier].update.required === true){
                let keyName = event.target.id;
                if(event.target.value)
                {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event.target.value;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                }
            }
        }
        if(updateOrderForm[inputIdentifier].elementType == 'multiselect') {
            if(updateOrderForm[inputIdentifier].update.required === true){
                if((Array.isArray(updateOrderForm[inputIdentifier].value) && 
                updateOrderForm[inputIdentifier].value.length !== 0) || (props.title == 'Inventory' && inputIdentifier == 'product'))
                {    
                  let arrayConvert = [];
                  if((Array.isArray(updateOrderForm[inputIdentifier].value))) {
                  updateOrderForm[inputIdentifier].value.map(function(fValue, indexId){
                    arrayConvert[indexId] = fValue.value;
                  })
                } else 
                arrayConvert[0]=0;
                  if(props.title == 'Inventory' && inputIdentifier == 'product')
                    {
                        let URL = updateOrderForm[inputIdentifier].update.endPoint;
                        let body = {product:arrayConvert,...commonParams}
                       setloadSForm(true);
                         const getdrpdwnresponseJson = await PostAPI(URL,body);
                       const dropVal = {
                           ...getdrpdwnresponseJson.data.data
                       }
                       let obj;
                       obj = Object.keys(getdrpdwnresponseJson.data.data).forEach((el) => {
                           if( Object.keys(el, updateOrderForm)){
                                       updateOrderForm['storage_location'].elementConfig.options = dropVal['storage_location'];
                           }
                       })
                       setFilterformValues(updateOrderForm);
                       setloadSForm(false);
                        
                    }else {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+arrayConvert;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                    }
                }else {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'=0';
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                   
                }
            }
        }
    }

    async function updateDropDwon(URL, FormVal){
        setloadSForm(true);
        props.setSelectChildValue();
          const getdrpdwnresponse = await FetchAPI(URL);
          const getdrpdwnresponseJson = await getdrpdwnresponse.json();
          const updateForm = {
            ...FormVal
        }
        const dropVal = {
            ...getdrpdwnresponseJson.data
        }
        let obj;
        obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
            if( Object.keys(el, updateForm)){
                updateForm[el].value=null;
                    if(updateForm[el].elementType == 'select'){
                        updateForm[el].elementConfig.options = dropVal[el];
                        updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                    }
                    else if(updateForm[el].elementType == 'multiselect') {
                        updateForm[el].elementConfig.options = dropVal[el];
                    }   
            }
        })
        setFilterformValues(updateForm);
        setloadSForm(false);
      }

    useEffect(() => {
        (async () => {
            if(props.dropDownApi === 'not found'){
                setloadSForm(false);
            }
            else
            {
                setloadSForm(true);
                let getdrpdwnresponseJson
                if(props?.dropdownMethod === "POST"){
                    const formData = new FormData();
                    formData.append("type","fetch_all_po_loc_ean");
                    const response = await PostAPI(props.dropDownApi,formData);
                    response.data.data.newPO = response.data.data.all_po_number
                    response.data.data.oldPO = response.data.data.all_po_number
                    response.data.data.oldLocation = response.data.data.all_locations
                    response.data.data.newLocation = response.data.data.all_locations
                    response.data.data.oldEAN = response.data.data.all_products
                    response.data.data.newEAN = response.data.data.all_products
                    delete response.data.data.status;
                    delete response.data.data.message;
                    getdrpdwnresponseJson = response.data;
                }else{
                    getdrpdwnresponse = await FetchAPI(props.dropDownApi);
                    getdrpdwnresponseJson = await getdrpdwnresponse.json();
                }
                const updateForm = {
                    ...FilterformValues
                }
                const dropVal = {
                    ...getdrpdwnresponseJson.data
                }
                
                {props.commonTitle === 'Revert Assigned' && delete getdrpdwnresponseJson.data['po_number']}
                let obj;
                obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
                    if( Object.keys(el, updateForm)){
                        if(!isEmpty(dropVal[el])){
                            if(updateForm[el]?.elementType == 'select'){
                                if(el === 'lot_number'){
                                    const modifiedOptions = dropVal[el].reduce((lot_no, value) => {
                                        lot_no.push({ value: value[el], displayValue: value[el] });
                                        return lot_no;
                                      }, []);
                                    updateForm[el].elementConfig.options = modifiedOptions;
                                    updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                                }else if(el !== 'lot_number'){
                                updateForm[el].elementConfig.options = dropVal[el];
                                updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                                }
                            }
                            else if(updateForm[el]?.elementType == 'multiselect') {
                                updateForm[el].elementConfig.options = dropVal[el];
                            }
                            else if(updateForm[el]?.elementType == 'selectshowsearch'){
                                updateForm[el].elementConfig.options = dropVal[el];
                            }   
                        }
                        else
                        {
                            if(updateForm[el].elementType == 'select' )
                            updateForm[el].elementConfig.options = initialValue;
                            if(updateForm[el].elementType == 'multiselect' )
                            updateForm[el].elementConfig.options = null;
                        //updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                        }
                    }
                    setFilterformValues(updateForm);
                })
                setloadSForm(false);
            }
        })()
        return () => {
            resetFilterFormValues()
        }
    }, [])

    let rcount = 1;
    return (
        <div key="ModalMDIV" style={{ marginTop: '5px', marginBottom: '5px' }}>
            { (loadSForm === true || props.isFilterLoader === true) &&
            <div className="filter-loader">
            <div className='spanLoading'>
                 <span>Loading...</span>
             </div>
             <BeatLoader />
         </div>
            }
            <Card
            key="CardFilter" 
            plain
            filter={true}
            content={
                    <form key="ModalForm" onSubmit={(e) => e.preventDefault()} >
                        <Row md={12} key="ROW1">
                    {formElementsArray.map(function(formElement, indexIdx){
                        const RowData = <div className={(rcount++ === 3? "row" : '') }>
                            <MDBCol md="4" key={formElement.id} style={{height:'82px'}}>
                                <InputField
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={(formElement.config.value == null) ? '' : formElement.config.value }
                                labelName={formElement.config.label}
                                id={formElement.config.id}
                                isValidate={formElement.config.validate}
                                selectChildValue= {props.selectChildValue}
                                changed={ (event) => inputChangedHandler(event, formElement.id)}
                                validater={validator}
                                selectedFile={selectedFile}
                                fromDate={fromDate}
                                setFromDate={setFromDate}
                                toDate={toDate}
                                setToDate={setToDate}
                                title={props.title}
                                />
                                </MDBCol></div>;
                                rcount = (rcount++ === 3) ? 0 : rcount;
                                rcount++;
                        return (
                            <div key={ 'div'+indexIdx }>
                                {RowData}
                            </div>
                        );
                    })}
                    </Row>
                    <MDBRow key="ModalMDBROW1">
                        <MDBCol md="6" className="mb-6" key="ModalMDBCOL2"></MDBCol>
                        <MDBCol md="12" className="mb-6" key="ModalMDBCOL3">
                        {props?.filterCondition ? 
                        <span style={conditionTextStyles}>{`${t('filtered_Condition')}`}</span> : ""}
                            <div style={{float:'right'}} key="ModalDIV">
                            {props.title !== 'Stock Out' ?
                            <span>
                                <ButtonField color="danger" key="ModalCLRBTN" submit={ (event) => clearFunction(event)} BName={t("clear")} />
                                {props.title === 'Log' ? " "  : <ButtonField color="info" key="ModalSRCHBTN" submit={ (event) => checkValidationFirst() } BName={t("search")} />}
                            </span>   :
                            ''}
                                {(props.exportFilterButton === true && props?.exportFilterButtonName) ? <ButtonField color="info" submit={ (e) => filteredExport(e) } BName={props.exportFilterButtonName} /> : 
                                (props.exportFilterButton === true) ? <ButtonField color="info" submit={ (e) => filteredExport(e) } BName={t("filter_export")} /> : ''}
                                {(props.exportFilterButton1 === true) ? <ButtonField disabled={props.disabled} color="info" submit={ (e) => filteredExport1(e) } BName={props.exportFilterButtonName1} /> : ''}
                            </div>
                        </MDBCol>
                    </MDBRow>
                    </form>
                }
                />
        </div>
    );
}

export default FilterBox;